(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssd-dealer-locator"] && !Shopify.designMode) return;
  try {
    
function initialiseSsdLocator(root){
const select=root.querySelector('[data-ssd-country]');if(!select||select.dataset.ready)return;select.dataset.ready='true';
const cards=[...root.querySelectorAll('.ssd-dealer')],grid=root.querySelector('.ssd-dealer-grid'),status=root.querySelector('[data-ssd-count]'),frame=root.querySelector('[data-dealer-map]'),place=root.querySelector('[data-place]');let origin=null;let requestId=0;
function map(card){if(!card)return;cards.forEach(c=>c.classList.toggle('ssd-selected',c===card));const address=card.querySelector('address').textContent;frame.src='https://www.google.com/maps?q='+encodeURIComponent(card.querySelector('h3').textContent+' '+address)+'&output=embed';}
function distance(card){const rad=n=>n*Math.PI/180;const lat=Number(card.dataset.lat),lng=Number(card.dataset.lng);const dlat=rad(lat-origin[0]),dlng=rad(lng-origin[1]);const a=Math.sin(dlat/2)**2+Math.cos(rad(origin[0]))*Math.cos(rad(lat))*Math.sin(dlng/2)**2;return 6371*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));}
function render(){let visible=cards.filter(c=>select.value==='all'||c.dataset.country===select.value);cards.forEach(c=>{c.hidden=!visible.includes(c);c.querySelector('.ssd-distance').hidden=true;c.classList.remove('ssd-nearest');});if(origin){visible.sort((a,b)=>distance(a)-distance(b));visible.forEach((c,i)=>{const label=c.querySelector('.ssd-distance');c.classList.toggle('ssd-nearest',i===0);label.textContent=Math.round(distance(c))+' '+root.dataset.km;label.hidden=false;});}visible.forEach(c=>grid.appendChild(c));status.textContent=status.dataset.countTemplate.replace('__COUNT__',String(visible.length));map(visible[0]);}
select.addEventListener('change',()=>{requestId++;render();});cards.forEach(c=>c.querySelector('[data-map]').addEventListener('click',()=>map(c)));
root.querySelector('form').addEventListener('submit',async event=>{event.preventDefault();const query=place.value.trim();if(!query){origin=null;render();return;}const id=++requestId;status.textContent=root.dataset.loading;try{const response=await fetch('https://photon.komoot.io/api/?limit=5&q='+encodeURIComponent(query+(select.value==='all'?'':' '+select.options[select.selectedIndex].dataset.geocodeCountry)));if(!response.ok)throw Error();const data=await response.json();if(id!==requestId)return;const feature=data.features.find(f=>select.value==='all'||String(f.properties.countrycode).toUpperCase()===select.value);if(!feature)throw Error();origin=[feature.geometry.coordinates[1],feature.geometry.coordinates[0]];render();}catch(error){if(id===requestId){origin=null;render();status.textContent=root.dataset.error;}}});
root.querySelector('[data-geolocate]').addEventListener('click',()=>{const id=++requestId;status.textContent=root.dataset.loading;if(!navigator.geolocation){status.textContent=root.dataset.error;return;}navigator.geolocation.getCurrentPosition(position=>{if(id!==requestId)return;origin=[position.coords.latitude,position.coords.longitude];render();},()=>{if(id===requestId)status.textContent=root.dataset.error;},{timeout:10000,maximumAge:300000});});render();}
document.querySelectorAll('.ssd-locator').forEach(initialiseSsdLocator);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ssd-locator').forEach(initialiseSsdLocator));

  } catch(e) { console.error(e); }
})();
})();
